export default __webpack_public_path__ + "static/media/people.e9958900.png";